import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import BrandHeader from "../components/brand/BrandHeader";
import Footer from "../components/brand/Footer";

export default function Membership() {
  const [tiers, setTiers] = useState([]);
  useEffect(() => { api.get("/membership/tiers").then(({ data }) => setTiers(data)); }, []);

  return (
    <div className="min-h-screen bg-[#050505]">
      <BrandHeader />
      <section className="max-w-5xl mx-auto px-6 py-16 text-center">
        <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">Membership</p>
        <h1 className="mt-3 font-display text-5xl text-white">Inside the Circle</h1>
        <p className="text-white/65 max-w-2xl mx-auto mt-4">Curated privileges across our partner network. Permanent membership QR. Private events. Birthday rituals.</p>

        <div className="grid sm:grid-cols-2 gap-6 mt-14">
          {tiers.map((t) => (
            <div key={t.id} className="tsc-card p-8 text-left" data-testid={`tier-${t.id}`}>
              <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">{t.name}</p>
              <p className="font-display text-3xl text-white mt-2">{t.price > 0 ? `₱${t.price.toLocaleString()} / year` : "Complimentary · MVP"}</p>
              <p className="text-white/60 text-sm mt-3">{t.description}</p>
              <ul className="mt-6 space-y-2">
                {t.perks?.map((p, i) => (
                  <li key={i} className="text-white/75 text-sm flex gap-2"><span className="text-[#D4AF37]">◆</span>{p}</li>
                ))}
              </ul>
              {t.name === "Member" && (
                <Link to="/register" className="tsc-btn-gold w-full inline-block text-center mt-7" data-testid={`tier-cta-${t.id}`}>Activate Membership</Link>
              )}
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
